import script from "./StockLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./StockLayout.vue?vue&type=script&setup=true&lang=js"

import "./StockLayout.vue?vue&type=style&index=0&id=4470ad01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4470ad01"]])

export default __exports__